// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type PriceParity48Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const PriceParity48: FC<PriceParity48Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="M4 42v-3h18.5V14.8a6.068 6.068 0 0 1-2.325-1.475A6.068 6.068 0 0 1 18.7 11h-7.95L17 26.1c-.033 1.5-.675 2.775-1.925 3.825-1.25 1.05-2.775 1.575-4.575 1.575-1.8 0-3.325-.525-4.575-1.575C4.675 28.875 4.033 27.6 4 26.1L10.25 11H6V8h12.7a6.041 6.041 0 0 1 2.05-2.875C21.717 4.375 22.8 4 24 4c1.2 0 2.283.375 3.25 1.125A6.041 6.041 0 0 1 29.3 8H42v3h-4.25L44 26.1c-.033 1.5-.675 2.775-1.925 3.825-1.25 1.05-2.775 1.575-4.575 1.575-1.8 0-3.325-.525-4.575-1.575-1.25-1.05-1.892-2.325-1.925-3.825L37.25 11H29.3a6.068 6.068 0 0 1-1.475 2.325A6.068 6.068 0 0 1 25.5 14.8V39H44v3H4Zm29.75-16h7.5l-3.75-9.2-3.75 9.2Zm-27 0h7.5l-3.75-9.2L6.75 26ZM24 12c.7 0 1.292-.25 1.775-.75.483-.5.725-1.083.725-1.75 0-.7-.242-1.292-.725-1.775C25.292 7.242 24.7 7 24 7c-.667 0-1.25.242-1.75.725S21.5 8.8 21.5 9.5c0 .667.25 1.25.75 1.75S23.333 12 24 12Z" />
        </svg>
    );
};

export default PriceParity48;
